export var TITLE = 'Nvidia';
export var TEXT_MULTIPLE = 0.5;
export var SPACE_MULTIPLE = 0.15;
export var COLOR_PRIMARY = '#74B71B';